import React, {useEffect} from 'react'
import MobileUserProfile from '@feature/portfolio/components/MobileUserProfileHeader/components/MobileUserProfile'
import MobileUserSubInformation from '@feature/portfolio/components/MobileUserProfileHeader/components/MobileUserSubInformation'
import MobileUserProfileOperations from '@feature/portfolio/components/MobileUserProfileHeader/components/MobileUserProfileOperations'
import {useRouter} from 'next/router'

interface IProps {
    className?: string
    id?: string
    login_id?: string
}

const MobileUserProfileHeader = ({className, id, login_id}: IProps) => {
    const router = useRouter()

    if (router?.pathname.includes('history') || router?.pathname.includes('payment')) return null
    return (
        <div className={`hidden sm:block pt-[20px] px-[10px] space-y-[7px] ${className}`}>
            <MobileUserProfile id={id} login_id={login_id} />

            <MobileUserSubInformation id={id} login_id={login_id} />

            <MobileUserProfileOperations id={id} login_id={login_id} />
        </div>
    )
}
export default MobileUserProfileHeader
